export enum OperatorsEnum {
  include = 'include',
  exclude = 'exclude',
}

export type Filter = {
  operator: OperatorsEnum;
  values: string[];
};
